import Layout from "../../layout/main";
import UserDetail from "../../components/customerMyOrganization/userDetail";
/**
 * CustomerUserDetail
 *
 * صفحه جزئیات کاربر مشتری که جزئیات مربوط به کاربر را نمایش می‌دهد.
 * این صفحه از Layout اصلی برای ساختار کلی استفاده می‌کند.
 *
 * ویژگی‌ها:
 * - استفاده از Layout برای قرار دادن محتوا در قالب استاندارد اپلیکیشن
 * - نمایش کامپوننت UserDetail که اطلاعات کاربر را ارائه می‌دهد
 *
 * @returns JSX.Element
 */

const CustomerUserDetail = () => {
  return (
    <Layout>
      <UserDetail />
    </Layout>
  );
};

export default CustomerUserDetail;
